import {
  JobStatusEnum,
  JobStatusEnumValueType,
} from '../job/types/job-status-enum';

import { Tag, TagProps } from './tag';

const jobStatuses: Record<
  JobStatusEnumValueType,
  {
    label: string;
    color: TagProps['color'];
  }
> = {
  [JobStatusEnum.valuesEnum.NotStarted]: {
    label: 'Not started',
    color: 'gray-light',
  },
  [JobStatusEnum.valuesEnum.InProgress]: {
    label: 'In progress',
    color: 'blue-light',
  },
  [JobStatusEnum.valuesEnum.Completed]: {
    label: 'Completed',
    color: 'green-light',
  },
  [JobStatusEnum.valuesEnum.Closed]: {
    label: 'Closed',
    color: 'red-light',
  },
};

/** @deprecated `JobStatusBadge` has been deprecated. Use StatusBadge instead. */
export const JobStatusBadge: React.FC<{
  status: JobStatusEnumValueType;
  testId?: string;
}> = ({ status, testId = 'job-status-badge' }) => {
  const { label, color } = jobStatuses[status];
  return <Tag color={color} label={label} data={{ testid: testId }} />;
};
